<!--
aktuellen Status der Sensoren anzeigen
-->
<template>

  <transition name="fade" mode="out-in">

    <div class="card mt-3" v-if="sensoren && sensoren.length > 0">
      <div class="card-header" @click="showSensorStatus = !showSensorStatus" style="cursor: pointer">
        <div class="row">
          <div class="col-md-8 text-left">
            <h3 class="h4 text-left">{{ $t('message.showHideSensorStatus') }}</h3>
          </div>
          <div class="col-md-4 text-right">
            <b-icon icon="caret-down" font-scale="2" v-if="!showSensorStatus"></b-icon>
            <b-icon icon="caret-up" font-scale="2" v-else></b-icon>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div class="card-body" v-if="showSensorStatus">

          <SensorStatus v-model="sensoren" />

        </div>
      </transition>
    </div>

  </transition>

</template>
<script>

  // Define a new component
  import axios from 'axios';
  import SensorStatus from "@/components/sensor/SensorStatus.vue";

  export default {

    name: 'ShowHideSensorStatus',
    components: {
      SensorStatus,
    },
    /*
      Defines the data used by the component
    */
    data: function () {
      return {
        /** Sensoren Status ein/ausblenden */
        showSensorStatus: false,
        /** Sensorenliste */
        sensoren: null,
      }
    },
    computed: {

      /** ID des aktuell ausgewählten Kunden - Sensoren gehören zum Kunden, nicht zum Bericht */
      customerId: function () {
        const customer = this.$store.getters.customer
        return customer ? customer.id : null
      },

    },
    watch: {

      // nur neu laden wenn sich der Kunde wechselt - die Sensoren sind kundenbezogen,
      // nicht bericht-bezogen, ein Wechsel zwischen Besuchs-/Traplinkedberichten desselben
      // Kunden braucht keinen Refresh
      customerId: function () {
        this.scheduleInit()
      },

    },
    mounted: function () {
      this.scheduleInit()
    },
    methods: {

      /**
       * sammelt mehrere init-Aufrufe in einem Zeitfenster von 300ms zu einem.
       * Verhindert, dass mounted und die watcher von traplinkedbericht/
       * besuchsbericht init mehrfach hintereinander auslösen, auch wenn die
       * Props zeitversetzt gesetzt werden (was $nextTick nicht abfängt).
       */
      scheduleInit: function () {

        if (this._initTimer) {
          clearTimeout(this._initTimer)
        }
        this._initTimer = setTimeout(() => {
          this._initTimer = null
          this.init()
        }, 300)

      },
      init: function () {

        const customer = this.$store.getters.customer
        if (!customer) {
          return
        }

        // sensoren NICHT auf null zurücksetzen, sonst greift v-if="sensoren && length > 0"
        // und SensorStatus wird komplett unmounted/remounted - dadurch geht der
        // pro-Sensor Loading-State verloren und die Spinner flickern unsichtbar weg.
        const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getSensoren'
        const params  = {
          customer_id: customer.id
        }

        const that = this
        axios({
          method: 'GET',
          params: params,
          url: url
        }).then(response => {

          if (response.data && response.data.sensorCustomer instanceof Array) {
            that.sensoren = response.data.sensorCustomer
          }

        }).catch(error => {
          console.log(error)
        })

      },

    }

  }

</script>
